export class AbortError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = "AbortError";
  }

  static is(obj: any): obj is AbortError {
    return Boolean(obj && obj.name === "AbortError");
  }
}
